import { Editor } from '../core';
import {
  selectNextBracket,
  selectNextHeadingSectionBracket,
  selectPreviousBracket,
  selectPreviousHeadingSectionBracket,
} from './bracketNavigation';

type NavigationOptions = {
  editor: Editor;
  ignoreMergeFieldsInNavigation?: boolean;
};

type ForwardNavigationOptions = NavigationOptions & {
  fallbackPoint?: 'start' | 'end';
};

export const navigateForward = ({
  editor,
  ignoreMergeFieldsInNavigation,
  fallbackPoint,
}: ForwardNavigationOptions): boolean => {
  if (selectNextBracket(editor, { ignoreMergeFieldsInNavigation })) {
    return true;
  }

  return (
    selectNextHeadingSectionBracket(editor, {
      fallbackPoint,
      ignoreMergeFieldsInNavigation,
    }) != null
  );
};

export const navigateBack = ({
  editor,
  ignoreMergeFieldsInNavigation,
}: NavigationOptions): boolean => {
  if (selectPreviousBracket(editor, { ignoreMergeFieldsInNavigation })) {
    return true;
  }

  return selectPreviousHeadingSectionBracket(editor, { ignoreMergeFieldsInNavigation }) != null;
};
